import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import api from "@/lib/api";
import { initCapacitor } from "@/lib/capacitor";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// Inicialización del shell nativo (Capacitor). No-op en navegador.
initCapacitor(api).catch(() => {});

// Register service worker (PWA + push notifications)
if ("serviceWorker" in navigator && window.location.protocol === "https:") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {});
  });

  navigator.serviceWorker.addEventListener("message", (event) => {
    if (event.data?.type === "notification-click" && event.data?.url) {
      window.location.href = event.data.url;
    }
  });
}
